import {
  EVALUATE_RECORD_DELETE_OK,
  EVALUATE_RECORD_DELETE_ERR,
} from "./delete.action";

const InitState = {
  error: null,
  content: null,
};

export default function EvaluateRecordDeleteReducer(state = InitState, action) {
  switch (action.type) {
    case EVALUATE_RECORD_DELETE_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case EVALUATE_RECORD_DELETE_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }
    default:
      return state;
  }
}
